import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patrocinio',
  templateUrl: './patrocinio.component.html',
  styleUrls: ['./patrocinio.component.scss']
})
export class PatrocinioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
